function MOMENTUM() {
};

MOMENTUM.analysis = function(technical, data) {
	// console.log("===============MOMENTUM.analysis start ==================");
	let param = technical.params[0];
	let paramSignal = technical.params[0];

	technical.data = {};
	
	let resultMo = new Array();
	let resultMoSignal =  new Array();
	technical.data["resultMo"] = resultMo;
	technical.data["resultMoSignal"] = resultMoSignal;

	let startIndex = Math.max(param, resultMo.length-1);
//	let startIndex = param + findIndexNotAdj(data);
	//LOOPでインデックスがstartIndexから最後までのモメンタムとその移動平均線を求め
	for (let m_current = startIndex ; m_current < data.length; m_current++) {
		let v  = MOMENTUM.calcMOMENTUM(data, m_current, param, startIndex);
		
		if (isNaN(v) || isNaN(param)) {
			resultMo[m_current] = undefined;
		} else {
			resultMo[m_current] = v;
		}
		
		if (m_current - startIndex > param + paramSignal - 2) {
			let sum = 0;
			for (let i = m_current; i > m_current - paramSignal; i--) {
				sum += resultMo[i];
			}
			if (isNaN(paramSignal) == false) {
				resultMoSignal[m_current] = sum / paramSignal;
			}
		}
	}
};

MOMENTUM.calcMOMENTUM = function(data, position, param) {
	if (data[position].close != null && data[position - param].close != null) {
		return data[position].close - data[position - param].close;
	} else {
		return undefined;
	}
};

window.MOMENTUM = MOMENTUM
